function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.2,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 1010 1010",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 378H0V0h378v378zm630 0H630V0h378v378zm-630 630H0V630h378v378zm630 0H630V630h378v378z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    style: {
      "fill": "rgb(48, 48, 48)"
    }
  })));
};

export default __webpack_public_path__ + "static/media/grid.412ef0b6.svg";
export { SvgComponent as ReactComponent };